import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./GetInTouchHome.css"; 
import Button from "../Button/Button";

const GetInTouchHome = () => {
  return (
    <div className="get-in-touch-banners">
      <Container>
        <Row className="align-items-center justify-content-between">
          {/* Left Side - Heading */}
          <Col xs={12} md={1} className="text-center text-md-end"></Col>
          <Col xs={12} md={7} className="text-center text-md-start">
            <h1 className="get-in-touch-heading">Smarter AI. Stronger Future.</h1>
          </Col>

          {/* Right Side - Button */}
          <Col xs={12} md={2} className="text-center text-md-end">
          <a href="/contact-us">
            <Button variant="light" className="get-in-touch-btn" color="banner">
              Get in Touch
            </Button>
            </a>
          </Col>
          <Col xs={12} md={2} className="text-center text-md-end"></Col>
        </Row>
      </Container>
    </div>
  );
};

export default GetInTouchHome;
